import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import theme from "../../style/theme";
import ExpandLessIcon from "../icons/ExpandLessIcon/ExpandLessIcon";
import ExpandMoreIcon from "../icons/ExpandMoreIcon/ExpandMoreIcon";
import {useClickOutside} from "../../utils/click/handle-click";

interface Props {
  defaultKey?: string;
  onClickSelectItem: (key: string) => void;
  value?: string;
  candidateMap: { [key: string]: string };
  width?: string;
  isError?: boolean;
  placeholder?: string;
}

export const BasicSingleSelector: React.FC<Props> = ({
  defaultKey,
  value,
  onClickSelectItem,
  candidateMap,
  width,
  isError,
  placeholder,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleClickBox = () => {
    setOpen(!open);
  };

  useClickOutside(ref, () => setOpen(false));

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <SelectedItem width={width} onClick={handleClickBox} isError={isError}>
        {!value && placeholder ? (
          <PlaceholderItemLabel>{placeholder}</PlaceholderItemLabel>
        ) : (
          <SelectedItemLabel>{value || defaultKey}</SelectedItemLabel>
        )}

        <RightSelectedItemWarpper>
          <Divider />
          <SelectedIconWarpper>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </SelectedIconWarpper>
        </RightSelectedItemWarpper>
      </SelectedItem>
      {open && (
        <MenuItemList width={width}>
          {Object.keys(candidateMap).map((candidate) => {
            const isSelected = value === candidate;
            return (
              <MenuItem
                key={candidate}
                selected={isSelected}
                onClick={() => {
                  onClickSelectItem(candidate);
                  handleClickBox();
                }}
              >
                <MenuItemLabel>{candidateMap[candidate]}</MenuItemLabel>
              </MenuItem>
            );
          })}
        </MenuItemList>
      )}
    </div>
  );
};

interface SelectedItemProps {
  width?: string;
  isError?: boolean;
  placeholder?: string;
}

const SelectedItem = styled.div<SelectedItemProps>`
  width: ${(props) => props.width || "14.25rem"};
  height: 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  border: 1px solid
    ${(props) =>
      props.isError
        ? theme.palette.primitives.red500
        : theme.palette.primitives.gray300};
  background-color: ${theme.palette.primitives.white};
  &:hover {
    background-color: #f5f6f9;
  }
`;

const SelectedItemLabel = styled.div`
  width: 76%;
  margin-left: 0.75rem;
  font-style: normal;
  font-weight: 500;
  font-size: 0.938rem;
  color: ${theme.palette.primitives.gray700};

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PlaceholderItemLabel = styled.div`
  height: 2.625rem;
  margin-left: 0.75rem;
  color: ${theme.palette.primitives.gray300};
  display: flex;
  align-items: center;
  font-style: normal;
  font-size: 15px;
  line-height: 18px;
  font-weight: 300;
`;

const RightSelectedItemWarpper = styled.div`
  // width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Divider = styled.div`
  width: 1px;
  height: 26px;
  background: ${theme.palette.primitives.gray200};
`;

const SelectedIconWarpper = styled.div`
  display: flex;
  padding: 0px 9px;
  justify-content: center;
  align-items: center;
`;

const CircleCloseFillIconWarpper = styled.div`
  padding: 0px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

interface MenuItemListProps {
  width?: string;
}

const MenuItemList = styled.div<MenuItemListProps>`
  width: ${(props) => props.width || "14.25rem"};
  max-height: 12.188rem;
  padding: 6.5px 0;
  position: absolute;
  background-color: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);
  border: solid 1px #bec3cb;
  z-index: 500;
  // max-height: calc(100vh - 400px);
  overflow-y: scroll;
  overflow-x: hidden;

  /* 스크롤 바 스타일 */
  &::-webkit-scrollbar {
    width: 5px;
    background-color: #ffffff;
  }

  /* 스크롤바 색상 */
  &::-webkit-scrollbar-thumb {
    background-color: #1c2026;
    border-radius: 10px;
  }

  /* 스크롤바가 마우스 오버될 때 색상 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #bfbfbf;
  }
`;

interface MenuItemProps {
  selected: boolean;
}

const MenuItem = styled.div<MenuItemProps>`
  padding-left: 12px;
  height: 36px;
  display: flex;
  color: #3f444e;
  align-items: center;
  background-color: ${(props) =>
    props.selected ? theme.palette.primitives.yellow50 : "#ffffff"};
  &:hover {
    background-color: #f5f6f9;
  }
  font-size: 14px;
  font-weight: 500;
`;

const LeftMenuItemIconWarpper = styled.div`
  width: 42px;
  height: 36px;
  box-sizing: border-box;
  padding: 9px 8px 9px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MenuItemLabel = styled.div`
  height: 2.5rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${theme.palette.primitives.black};
  display: flex;
  align-items: center;
`;
